import { createPmremGenerator } from './pmrem-generator.factory';
import { loadRgbeTexture } from '../../loader';

export { createEnvironmentMap };

async function createEnvironmentMap(
    renderer,
    pathToMapFile,
    { basePath } = {}
) {
    if (!pathToMapFile) return null;
    const pmremGenerator = createPmremGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();

    const texture = await loadRgbeTexture(pathToMapFile, { basePath });
    return pmremGenerator.fromEquirectangular(texture).texture;
}
